export const formatIndianCurrency = (
  amount: number,
  options: { showSymbol?: boolean; minimumFractionDigits?: number; maximumFractionDigits?: number } = {}
): string => {
  const { showSymbol = true, minimumFractionDigits = 2, maximumFractionDigits = 2 } = options;

  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits,
    maximumFractionDigits,
  });

  const formatted = formatter.format(Math.abs(amount));
  return showSymbol ? formatted : formatted.replace('₹', '').trim();
};

export const formatCompactCurrency = (amount: number): string => {
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    notation: 'compact',
    maximumFractionDigits: 1,
  });
  return formatter.format(amount);
};

export const maskAccountNumber = (accountNumber: string): string => {
  const clean = accountNumber.replace(/\D/g, '');
  if (clean.length <= 4) return clean;
  const lastFour = clean.slice(-4);
  return `XXXX XXXX ${lastFour}`;
};
